import React, { PropTypes } from 'react'
import { dateFormatter } from 'lib/helpers'
import rt from 'components/reactable.scss'
import { Table, Thead, Th, Tr, Td } from 'components/reactable'
import styles from './client.scss'
import i18n from 'lib/i18n'
import cs from 'classnames'

const _ = i18n('profile')

const Documents = ({ documents, className }) => (
	<div className={className}>
		<div className={styles.header}>
			{_('files')}
		</div>
		<Table
			className="table"
			itemsPerPage={15}
			filterPlaceholder={_('placeholder')}
			filterable={['documentType', 'documentDate']}
			sortable={[
				{ column: 'documentDate', sortFunction: 'Date' },
				'documentType',
			]}
			defaultSort={{
				column: 'documentDate',
				direction: 'desc',
			}}
		>
			<Thead>
				<Th column="documentMetaCol" label="" />
				<Th column="documentType">
					<strong>{_('type')}</strong>
				</Th>
				<Th column="documentDate">
					<strong>{_('date')}</strong>
				</Th>
			</Thead>
			{documents && documents.length > 0 &&
				documents.map((item, i) => (
					<Tr
						i={item.id}
						key={i}
						className="clickable"
						onClick={() => window.open(`/data/document?id=${item.clientDocumentId}`, '_blank', 'noopener,noreferrer')}
					>
						<Td column="documentMetaCol" data={item.id} className={cs(styles.documentIcon, rt.pdfIcon)}>
							<div><img src={require('resources/images/pdf-icon_1x.png')} /></div>
						</Td>
						<Td column="documentType" data={item.clientDocumentType} />
						<Td column="documentDate" className={styles.documentDate} data={dateFormatter(item.clientDocumentDate)} />
					</Tr>
				))
			}
		</Table>
	</div>
)
Documents.propTypes = {
	documents: PropTypes.array.isRequired,
	className: PropTypes.string,
}
export default Documents



// WEBPACK FOOTER //
// ./elements/ClientDocuments.jsx